import './search_page.scss';

import '../../../common/privacy/privacy';
import {
  hubEventLoadDispatch,
  sharedHubEventsInit,
} from '../../../common/hub_events/shared_hub_events';
import bodyTopInit from '../../components/body_top/body_top';
import footerInit from '../../components/footer/footer';
import setFocusToElement from '../../components/see_more_button/see_more_button';

const loadMoreButtons = [...document.querySelectorAll('.load-more-search-results')];
const filterByAll = document.getElementById('search-filter-all');
const filterByStream = document.getElementById('search-filter-stream');
const resultsList = '.search-results-list';
const maxItems = 5;
const paramStream = 'ufs';
const paramFilter = 'uff';

const getURLParameter = (param: string) => {
  const params = window.location.search;
  const paramName = param.replace(/[[\]]/g, '\\$&');
  const regex = new RegExp(`[?&]${paramName}(=([^&#]*)|&|#|$)`);
  const results = regex.exec(params);

  if (!results) return null;
  if (!results[2]) return '';

  return decodeURIComponent(results[2].replace(/\+/g, ' '));
};

const addURLParameter = (param: string) => {
  let url = window.location.href;
  url += (url.split('?')[1] ? '&' : '?') + param;
  window.location.href = url;
};

const removeURLParameter = (removeParam: string) => {
  const urlParts = window.location.href.split('?');
  const prefix = `${encodeURIComponent(removeParam)}=`;
  const params = urlParts[1].split(/[&;]/g);

  params.forEach((param, i) => {
    if (param.lastIndexOf(prefix, 0) !== -1) {
      params.splice(i, 1);
    }
  });

  window.location.href = urlParts[0] + (params.length > 0 ? `?${params.join('&')}` : '');
};

const enableResultsFilter = () => {
  const isStreamFiltered = getURLParameter(paramFilter);

  if (!filterByAll || !filterByStream) return;

  if (isStreamFiltered) {
    filterByAll.removeAttribute('disabled');
  } else {
    filterByStream.removeAttribute('disabled');
  }
};

const onFilterByAll = (e: Event): void => {
  e.preventDefault();
  removeURLParameter(paramFilter);
};

const onFilterByStream = (e: Event): void => {
  const streamId = getURLParameter(paramStream);
  e.preventDefault();
  addURLParameter(`${paramFilter}=${streamId}`);
};

const onShowMoreResults = (e: Event): void => {
  e.preventDefault();
  const button = e.target as HTMLElement;
  const hiddenClass = 'is-hidden';

  if (!button.parentNode) return;
  const parent = button.parentNode.querySelector(resultsList);

  if (!parent) return;
  const items = [...parent.querySelectorAll(`.${hiddenClass}`)];

  items.forEach((item: Element, i: number) => {
    if (i < maxItems) {
      item.classList.remove(hiddenClass);
    }
  });

  setFocusToElement(items[0]);

  if (items.length <= maxItems) {
    button.classList.add(hiddenClass);
  }
};

const eventsInit = () => {
  loadMoreButtons.forEach((button: Element) => {
    button.addEventListener('click', onShowMoreResults);
  });

  if (!filterByAll || !filterByStream) return;
  filterByAll.addEventListener('click', onFilterByAll);
  filterByStream.addEventListener('click', onFilterByStream);
};

const init = () => {
  sharedHubEventsInit();
  eventsInit();
  enableResultsFilter();
  bodyTopInit();
  footerInit();
  hubEventLoadDispatch();
};

document.addEventListener('DOMContentLoaded', init);
